import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
import _ from "underscore";
const number_format = new Intl.NumberFormat("en-US");
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {
    
    watch:{

        async 'form_data.building_id'(val)
        {
            if(val)
            {
                let http_request = {
                    id:             val,
                    type_request:   'building',
                }
                const response = await this.get(`${this.lite_rest_api2}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.length)
                    {
                        this.array_options['area_id'] = response.data
                        this.form_data.area_id = ''
                        notyf.success('Areas available for the selected level')
                    }
                    else
                    {
                        this.array_options['area_id'] = []
                        this.form_data.area_id = ''
                        notyf.error('No areas available for the selected building')
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },
    },

    methods: {

        async api_request_lite()
        {
            let json_request = {
                id:             this.parent_id,
                type_request:   'child_rooms',
            }
            
            const response = await this.get(`${this.lite_rest_api2}/${JSON.stringify(json_request)}`)

            if(response.status)
            {
                this.rooms_assigned = response.data.rooms_assigned
                if(this.rooms_assigned.length)
                {
                    this.rooms_assigned.map(item => item['checked'] = false)

                    const frequencies = this.rooms_assigned.map(item => ({ room_id: item.room_id, task_id: item.task_id, total_frequency: item.total_frequency}))
                    const tasks = _.uniq(frequencies, item => [item.room_id, item.task_id].join());
                    for (const task of tasks) {
                        this.frequencies[`${task.room_id}${task.task_id}`] = {
                            total_frequency : task.total_frequency
                        }
                    }
                }
            } 
            else
            {
                this.loader()
                this.error_handling(response)
            }
        },

        globalStatistics(rooms)
        {

            let monday_minutes    = []
            let tuesday_minutes   = []
            let wednesday_minutes = []
            let thursday_minutes  = []
            let friday_minutes    = []
            let saturday_minutes  = []
            let sunday_minutes    = []

            let monday_square    = []
            let tuesday_square   = []
            let wednesday_square = []
            let thursday_square  = []
            let friday_square    = []
            let saturday_square  = []
            let sunday_square    = []

            let global_sq_ft    = []
            let global_minutes  = []

            const currentDate = new Date();
            const currentDay = currentDate.getDay();

            this.current_day_number = currentDay

            rooms.forEach(item => {

                global_minutes.push(item.minutes)
                global_sq_ft.push(parseFloat(item.sq_ft))

                if(item.monday)
                {
                    monday_minutes.push(item.minutes)
                    monday_square.push(parseFloat(item.sq_ft))
                }
                if(item.tuesday)
                {
                    tuesday_minutes.push(item.minutes)
                    tuesday_square.push(parseFloat(item.sq_ft))
                }
                if(item.wednesday)
                {
                    wednesday_minutes.push(item.minutes)
                    wednesday_square.push(parseFloat(item.sq_ft))
                }
                if(item.thursday)
                {
                    thursday_minutes.push(item.minutes)
                    thursday_square.push(parseFloat(item.sq_ft))
                }
                if(item.friday) 
                {
                    friday_minutes.push(item.minutes)
                    friday_square.push(parseFloat(item.sq_ft))
                }
                if(item.saturday)
                {
                    saturday_minutes.push(item.minutes)
                    saturday_square.push(parseFloat(item.sq_ft))
                }
                if(item.sunday) 
                {
                    sunday_minutes.push(item.minutes)
                    sunday_square.push(parseFloat(item.sq_ft))
                }

            })



            this.single_object.total_time = number_format.format(this.sumArrays(global_minutes, true));

            this.minutes_results = [
                {
                    total: this.sumArrays(sunday_minutes, true)
                },
                {
                    total: this.sumArrays(monday_minutes, true)
                },
                {
                    total: this.sumArrays(tuesday_minutes, true)
                },
                {
                    total: this.sumArrays(wednesday_minutes, true)
                },
                {
                    total: this.sumArrays(thursday_minutes, true)
                },
                {
                    total: this.sumArrays(friday_minutes, true)
                },
                {
                    total: this.sumArrays(saturday_minutes, true)
                },
                {
                    total: this.single_object.total_time,
                },
            ]

            this.all_total_minutes = Number(this.minutes_results[currentDay].total) + Number(this.summed_daily_minutes)

            this.square_results = [
                {
                    total: this.sumArrays(sunday_square, true)
                },
                {
                    total: this.sumArrays(monday_square, true)
                },
                {
                    total: this.sumArrays(tuesday_square, true)
                },
                {
                    total: this.sumArrays(wednesday_square, true)
                },
                {
                    total: this.sumArrays(thursday_square, true)
                },
                {
                    total: this.sumArrays(friday_square, true)
                },
                {
                    total: this.sumArrays(saturday_square, true)
                },
                {
                    total: ''
                },
                {
                    total: this.sumArrays(global_sq_ft, true)
                },
            ]
        },

        sumArrays(array_number)
        {
            return array_number.reduce( (num1, num2) => { return num1 + num2 }, 0 ).toFixed(1)
        },

        async massDelete()
        {
            let checked_rooms = this.rooms_assigned.filter(item => item.checked)

            if(checked_rooms.length)
            {
                let confirmation = window.confirm('Are you sure you want to delete the selected duties?')

                if(confirmation)
                {
                    let rooms_id = checked_rooms.map(item => { return { 'id': item.id, 'room_id': item.room_id } })
        
                    let json_request = {
                        daily_assignment_id: this.parent_id,
                        requirement: 'mass_delete',
                    }
        
                    this.loader(true)
    
                    let response  = await this.patch(`${this.lite_rest_api2}/${JSON.stringify(json_request)}`, rooms_id)
        
                    if(response.status)
                    {
                        checked_rooms.forEach(item => 
                        {
                            let roomIndex = this.rooms_assigned.findIndex(prop => prop.id === item.id)
                            if(roomIndex > -1)
                            {
                                this.rooms_assigned.splice(roomIndex, 1)
                            }
                        })

                        notyf.success(`Success`)
                        this.basicRestore()
                        this.loader()
                    }
                    else
                    {
                        this.error_handling(response)
                        
                        this.loader()
                    }  
                } 
            }
            else
            {
                notyf.error(`There is no room selected available`)
            }
        },

        basicRestore()
        {
            this.rooms_assigned.map((item, i) => 
            {
                item.checked = false
                window.$(`#checkAll${i}`).prop('checked', false)
            })

            this.select_all = false
            window.$(`#theadcheck`).prop('checked', false)
        },

        saveNewSchedule(event)
        {
            let checked_rooms = this.rooms_assigned.filter(item => { return item.checked === true })
            if(checked_rooms.length)
            {
                checked_rooms.map(item => {
                    item.monday     = event.monday
                    item.tuesday    = event.tuesday
                    item.wednesday  = event.wednesday
                    item.thursday   = event.thursday
                    item.friday     = event.friday
                    item.saturday   = event.saturday
                    item.sunday     = event.sunday
                    this.rooms_assigned.findIndex(prop => prop.id === item.id)
                })
            }
            window.$('#static-schedule').modal('hide')
            setTimeout(() => {
                this.save_grid()
            }, 500)
        },

        scheduleModal()
        {
            let checked_rooms = this.rooms_assigned.filter(item => { return item.checked === true })
            if(checked_rooms.length)
            {
                window.$('#static-schedule').modal('show')
            }
            else
            {
                notyf.error(`There is no room selected available`)
            }
        },

        massEditSchedule(model)
        {
            this.rooms_assigned.forEach(item => item[model] = this.schedule_models[model])
        },

        async save_grid()
        {
            let allRooms = []
            this.rooms_assigned.forEach( item => {
                allRooms.push(
                    {
                        id:         item.id,
                        monday:     item.monday,
                        tuesday:    item.tuesday,
                        wednesday:  item.wednesday,
                        thursday:   item.thursday,
                        friday:     item.friday,
                        saturday:   item.saturday,
                        sunday:     item.sunday,
                    }
                )
            })

            let json_request = {
                requirement: 'mass_edit_grid',
                daily_assignment_id: this.single_object.id
            }

            this.loader(true)
            let response  = await this.patch(`${this.lite_rest_api2}/${JSON.stringify(json_request)}`, allRooms)

            if(response.status)
            {
                this.api_request_lite()
                this.basicRestore()
                this.globalStatistics(this.rooms_assigned)
                this.loader()
                notyf.success(`Success`)
            }
            else
            {
                this.error_handling(response)
                
                this.loader()
            }
        },

        reloaded()
        {
            this.loader()
            this.api_request(this.rest_api)
            this.select_all = false
            window.$(`#theadcheck`).prop('checked', false)
        },

        moveUp(index)
        {
            let indexUp = (index-1)
            let current_index = index

            let roomUp = {...this.rooms_assigned[indexUp]}
            let currentRoom = {...this.rooms_assigned[current_index]}

            this.rooms_assigned.splice(indexUp, 1, currentRoom)
            this.rooms_assigned.splice(current_index, 1, roomUp)
            this.orderRequest()
        },

        moveDown(index)
        {
            let indexDown = (index+1)
            let current_index = index

            let roomDown = {...this.rooms_assigned[indexDown]}
            let currentRoom = {...this.rooms_assigned[current_index]}

            this.rooms_assigned.splice(current_index, 1, roomDown)
            this.rooms_assigned.splice(indexDown, 1, currentRoom)
            this.orderRequest()
        },

        reorderByInput(item, new_order) 
        {
            if(new_order === '') {
                this.notyfMesg('Please enter a valid number', 'error')
                return
            }
            if(item.order > Number(new_order))
            {
                item.order = Number(new_order) - 1
            }
            else
            {
                item.order = Number(new_order) + 1
            }
            
            this.rooms_assigned.sort((a, b) => a.order - b.order);

            this.orderRequest(false)
        },

        async orderRequest(show_loader = true)
        {
            let rooms_id = []
            let backup_rooms = []

            if(show_loader)
            {
                this.loader(true)
            }

            let rooms_assigned = JSON.parse(JSON.stringify(this.rooms_assigned))
            rooms_assigned.forEach( (item, index) => {rooms_id.push(item.id); backup_rooms.push({...item, order: index + 1 })} )

            let json_request = {
                requirement: 'order',
            }
            this.draggable_reset = true
            let response  = await this.patch(`${this.lite_rest_api2}/${JSON.stringify(json_request)}`, rooms_id)

            if(response.status)
            {
                this.rooms_assigned = backup_rooms
                this.loader()
                this.draggable_reset = false
            }
            else
            {
                this.error_handling(response)
                
                this.loader()
            }
        },

        selectAllBoxes()
        {
            if(this.rooms_assigned.length)
            {
                this.rooms_assigned.map((item) => {
                    item.checked = this.select_all
                })
            }
        },

        async move_rooms(copy = false)
        {
            this.rooms_at_move = this.rooms_assigned.filter(item => item.checked).map(item => ({
                id: item.id,
                assignment_duty_note_id: item.assignment_duty_note_id,
                room_id: item.room_id,
                room_task_id: item.room_task_id,
                sunday: item.sunday,
                monday: item.monday,
                tuesday: item.tuesday,
                wednesday: item.wednesday,
                thursday: item.thursday,
                friday: item.friday,
                saturday: item.saturday,
                minutes: item.minutes,
                order: item.order,
                originally_moved_id: item.originally_moved_id,
                move_date: item.move_date
                

            }))

            const daily_assignments = JSON.parse(JSON.stringify(this.daily_assignments_collection))

            this.array_options_move.daily_assignment_id = daily_assignments.map(item =>  
            { 
                return {
                    name: `${item.number_assigment} - ${item.description}`, 
                    id: item.id
                }
            })
            this.total_minutes = this.sumArrays(this.rooms_assigned.map(item => item.minutes))

            if(copy)
            {
                window.$('#static-copy-room').modal('show')
                return true
            }
            if(this.hasPermissions(['Daily-Assignment Move-Rooms']) && this.hasPermissions(['Daily-Assignment Move-Rooms-For-Day']))
            {
                this.permission_move = 1
            }
            else if(this.hasPermissions(['Daily-Assignment Move-Rooms']))
            {
                this.permission_move = 2
            }
            else if(this.hasPermissions(['Daily-Assignment Move-Rooms-For-Day']))
            {
                this.permission_move = 3
            }
            else
            {
                this.permission_move = 0
            }

            window.$('#static-move').modal('show')
        },

        move()
        {
            this.rooms_assigned = this.rooms_assigned.filter(item => !item.checked)
            this.globalStatistics(this.rooms_assigned)
        },

    },

}

export default Methods